<template>
    <div class="reset-password">
        <div class="card">
            <div class="card-header">
                <h5 class="card-title text-center">Reset Password</h5>
                <hr>
            </div>
            <div class="card-body">
                <BasicTextInput label="Password"
                                type="password"
                                v-model="form.pw"
                                :validator="$v.form.pw"
                                :validatorMsgMap="pwMsgMap"
                                placeholder="Enter New Password"   class="mb-3"/>
                <BasicTextInput label="Confirm Password"
                                type="password"
                                v-model="form.pw_confirmation"
                                :validator="$v.form.pw_confirmation"
                                :validatorMsgMap="pwConfirmationMsgMap"
                                placeholder="Confirm New Password" class="mb-3"/>
                <button class="btn btn-primary btn-block" @click="submitNewPassword">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { validatorMsgMapBase } from "../modules/helpers";
    import {
        required,
        minLength,
        sameAs,
        helpers
    } from 'vuelidate/lib/validators';


    const hasDigit           = helpers.regex('hasDigit', /\d/);
    const hasUppercase       = helpers.regex('hasUppercase', /[A-Z]/);
    const hasNonAlphanumeric = helpers.regex('hasNonAlphanumeric', /\W/);

    import { UserService } from '@/services';

    export default {
        name: "ResetPassword",
        data: () => {
            return {
                validatorMsgMapBase: validatorMsgMapBase,
                form: {
                    pw: '',
                    pw_confirmation: '',
                }
            }
        },
        validations: {
            form: {
              pw: {
                  required,
                  minLength: minLength(8),
                  hasDigit,
                  hasUppercase,
                  hasNonAlphanumeric
              },
              pw_confirmation: {
                  required,
                  sameAsPassword: sameAs('pw'),
              }
            }
        },
        computed: {
            pwMsgMap(){
                return {
                    ...this.validatorMsgMapBase,
                    required:  'Password is Required',
                    minLength: 'Must be at least 8 Characters'};
            },
            pwConfirmationMsgMap(){
                return {...this.validatorMsgMapBase,
                    required:       'Password Confirmation is Required',
                    sameAsPassword: 'Must Match Password'};
            }
        },
        methods: {
            submitNewPassword(){
                this.$v.form.$touch();
                if (this.$v.form.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }

                let resetToken = this.$route.query.token;
                if (!resetToken) {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Missing Password Reset Token', type: 'error' });
                    return;
                }

                let data = {
                    token:    resetToken,
                    password: this.form.pw,
                };

                UserService.resetPassword(data).then(res => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Password Updated', type: 'success' });
                    this.$router.push({ name: 'Login'})
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
                })

            }
        }
    }
</script>

<style scoped lang="scss">
    .reset-password {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .card {
            max-width: 500px;
            min-width: 350px;
        }
    }
</style>
